export default function Accordion(theme) {
  return {
    MuiAccordion: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          boxShadow: 'none',
          border: `1px solid ${theme.palette.divider}`,
          '&:before': {
            display: 'none',
          },
          '&.Mui-expanded': {
            margin: theme.spacing(1, 0),
          },
          '&:first-of-type': {
            borderRadius: theme.shape.borderRadius,
          },
          '&:last-of-type': {
            borderRadius: theme.shape.borderRadius,
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          padding: theme.spacing(2, 3),
          minHeight: 56,
          '&.Mui-expanded': {
            minHeight: 56,
          },
        },
        content: {
          margin: theme.spacing(1.5, 0),
          '&.Mui-expanded': {
            margin: theme.spacing(1.5, 0),
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0, 3, 3),
        },
      },
    },
  };
}

